import { React, PT, fetchApi, withRouter } from '@gasbuddy/react';
import { Segment, Form, Header, Message, Button } from 'semantic-ui-react';

function tagsString(array) {
  return array ? array.join(',') : '';
}

function tagsArray(string) {
  return string ? string.split(',').map(s => s.trim()) : [];
}

class BaseInstrumentTools extends React.Component {
  state = {
    location: 'shell_boston',
    template: 'default',
    tags: null,
  }

  setTags = async (e) => {
    e.preventDefault();
    const { instrument, onChange } = this.props;
    // eslint-disable-next-line camelcase
    const oldTags = instrument?.extra_data?.tags || [];
    const { tags } = this.state;
    const newTags = tags || [];
    const addTags = newTags.filter(t => !oldTags?.includes(t));
    const removeTags = oldTags.filter(t => !newTags?.includes(t));
    const { status, body, error } = await fetchApi({
      url: '/payments/instrument/tags',
      body: {
        account_id: instrument.account_id,
        instrument_id: instrument.instrument_id,
        add_tags: addTags,
        remove_tags: removeTags,
      },
    });
    if (status === 200) {
      this.setState({ tagsError: null }, onChange);
    } else {
      this.setState({ tagsError: error || body });
    }
  }

  assign4 = (e) => {
    e.preventDefault();
    const { instrument, onChange } = this.props;
    this.setState({ loading: true }, async () => {
      await fetchApi({
        url: '/devtools/instrument/assign4',
        body: {
          instrument_id: instrument.instrument_id,
        },
      });
      this.setState({ loading: false }, onChange);
    });
  }

  shipCard = (e) => {
    e.preventDefault();
    const { instrument, onChange } = this.props;
    this.setState({ loading: true }, async () => {
      await fetchApi({
        url: '/devtools/instrument/shipCard',
        body: {
          instrument_id: instrument.instrument_id,
        },
      });
      this.setState({ loading: false }, onChange);
    });
  }

  microdeposit = (e) => {
    e.preventDefault();
    const { instrument, onChange } = this.props;
    this.setState({ loading: true }, async () => {
      await fetchApi({
        url: '/devtools/instrument/microdeposit',
        body: {
          instrument_id: instrument.instrument_id,
        },
      });
      this.setState({ loading: false }, onChange);
    });
  }

  cardType = () => {
    const { instrument } = this.props;
    if (instrument) {
      if (instrument.provider_name === 'gasbuddy'
        && instrument.instrument_type === 'private_card') {
        return 'wex';
      }
      if (instrument.provider_name === 'gasbuddy'
        && instrument.instrument_type === 'network_card') {
        return 'ads';
      }
      if (instrument.provider_name === 'pdi'
        && instrument.instrument_type === 'private_card') {
        return 'fleetcor';
      }
    }
    return '';
  }

  createTransaction = async (e) => {
    e.preventDefault();
    const { instrument, mapId, history } = this.props;
    const { template, location } = this.state;
    const cardType = this.cardType();
    const { status, body, error } = await fetchApi({
      url: `/devtools/transaction/create/${cardType === 'wex' ? '' : cardType}`,
      body: {
        account_id: instrument.account_id,
        instrument_id: instrument.instrument_id,
        instrument_account_map_id: mapId,
        template,
        location,
      },
    });
    if (status === 201) {
      history.push(`/payments/transaction/${body.transaction_id}`);
    } else {
      this.setState({ transactionError: error || body });
    }
  }

  createTransactionAuth = async (e) => {
    e.preventDefault();
    const { instrument, mapId, history } = this.props;
    const { location, template } = this.state;
    const { status, body, error } = await fetchApi({
      url: '/devtools/transaction-auth/create',
      body: {
        account_id: instrument.account_id,
        instrument_id: instrument.instrument_id,
        instrument_account_map_id: mapId,
        template,
        location,
      },
    });
    if (status === 200) {
      history.push(`/payments/transaction-auth/${instrument.account_id}/${body.transaction_auth_id}`);
    } else {
      this.setState({ txAuthError: error || body });
    }
  };

  render() {
    const { instrument, fulfillments } = this.props;
    const { transactionError, txAuthError, location, template, tags, tagsError, loading } = this.state;
    return (
      <div style={{ marginTop: 15 }}>
        <Header as="h3" block attached="top">
          Dev Tools
        </Header>
        <Segment attached>
          {instrument
            && instrument.provider_name === 'gasbuddy'
            && instrument.instrument_type === 'private_card'
            && (
            <Form horizontal error={!!transactionError}>
              {transactionError
                && (
                <Message error>
                  Unable to create transaction:
                  <pre>{JSON.stringify(transactionError, null, '\t')}</pre>
                </Message>
                )
              }
              <Form.Group inline>
                <Form.Dropdown
                  upward
                  label="Create a transaction @"
                  defaultValue={location}
                  options={[
                    { text: 'Shell - Boston', value: 'shell_boston' },
                    { text: 'Loves Test Store', value: 'loves_test' },
                    { text: 'Loves Nevada', value: 'nevada' },
                    { text: 'Loves Texas', value: 'texas' },
                    { text: 'GB HQ', value: 'gbhq' },
                    { text: 'Flying J', value: 'flyingj' },
                    { text: 'CITGO', value: 'citgo' },
                  ]}
                  onChange={(e, { value }) => this.setState({ location: value })}
                />
                <Form.Dropdown
                  upward
                  label="with template"
                  defaultValue={template}
                  options={[
                    { text: 'Regular Fillup', value: 'default' },
                    { text: 'Merchant Discount', value: 'discount' },
                    { text: 'Negative Transaction', value: 'negative' },
                    { text: 'Loves Mobile Payment', value: 'loves' },
                    { text: 'GasBack Earnings', value: 'gasback' },
                    { text: 'Large Transaction', value: 'bigpurchase' },
                  ]}
                  onChange={(e, { value }) => this.setState({ template: value })}
                />
                <Form.Button onClick={this.createTransaction}>Create</Form.Button>
              </Form.Group>
            </Form>
            )
          }
          <Form horizontal error={!!tagsError}>
            {tagsError
            && (
            <Message error>
              Unable to set tags:
              <pre>{JSON.stringify(tagsError, null, '\t')}</pre>
            </Message>
            )
            }
            <Form.Group inline>
              <Form.Field>
                <Form.Input
                  label="Edit Tags (comma separated)"
                  name="tags"
                  value={tagsString(tags
                                    || (instrument
                                     && instrument.extra_data
                                     && instrument.extra_data.tags))}
                  onChange={(e, { value }) => this.setState({ tags: tagsArray(value) })}
                  placeholder="Tags"
                  action={<Form.Button onClick={this.setTags}>Save</Form.Button>}
                />
              </Form.Field>
            </Form.Group>
          </Form>

          {instrument
            && instrument.instrument_type === 'bank_account'
            && instrument.extra_data?.tags?.includes('no-iav')
            && !instrument.extra_data?.tags?.includes('verified')
            && !instrument.extra_data?.tags?.includes('md-verified')
            && !instrument.extra_data?.tags?.includes('md-ready')
            && (
              <Button loading={loading} onClick={this.microdeposit}>Kick off Microdeposits</Button>
            )}

          {instrument
            && instrument.instrument_type === 'private_card'
            && instrument.provider_name === 'gasbuddy'
            && !instrument.extra_data?.last_digits
            && (
              <Button loading={loading} onClick={this.assign4}>Assign Last 4 Digits</Button>
            )}

          {fulfillments
            && fulfillments.find(f => (!f.ready_to_ship && !f.ship_date))
            && (
              <Button loading={loading} onClick={this.shipCard}>Mark Card Shipped</Button>
            )}
          {instrument
              && instrument.provider_name === 'gasbuddy'
              && instrument.instrument_type === 'network_card'
              && (
              <Form horizontal error={!!transactionError}>
                {transactionError
                  && (
                  <Message error>
                    Unable to create transaction:
                    <pre>{JSON.stringify(transactionError, null, '\t')}</pre>
                  </Message>
                  )
                }
                <Form.Group inline>
                  <Form.Dropdown
                    upward
                    label="Create a transaction @"
                    defaultValue={location}
                    options={[
                      { text: 'Shell - Boston', value: 'shell_boston' },
                      { text: 'GB HQ', value: 'gbhq' },
                    ]}
                    onChange={(e, { value }) => this.setState({ location: value })}
                  />
                  <Form.Dropdown
                    upward
                    label="with template"
                    defaultValue={template}
                    options={[
                      { text: 'Default ADS', value: 'default' },
                    ]}
                    onChange={(e, { value }) => this.setState({ template: value })}
                  />
                  <Form.Button onClick={this.createTransaction}>Create</Form.Button>
                </Form.Group>
              </Form>
              )
            }
          {instrument
              && instrument.provider_name === 'pdi'
              && instrument.instrument_type === 'private_card'
              && (
                <Form horizontal error={!!transactionError}>
                  {transactionError
                  && (
                  <Message error>
                    Unable to create transaction:
                    <pre>{JSON.stringify(transactionError, null, '\t')}</pre>
                  </Message>
                  )
                }
                  <Form.Group inline>
                    <Form.Dropdown
                      upward
                      label="Create a transaction @"
                      defaultValue={location}
                      options={[
                        { text: 'Shell - Boston', value: 'shell_boston' },
                        { text: 'Flying J', value: 'flyingj' },
                        { text: 'CITGO', value: 'citgo' },
                        { text: 'Murphy\'s', value: 'murphys' },
                        { text: '7-11', value: 'sevenEleven' },
                        { text: 'Casey\'s', value: 'caseys' },
                      ]}
                      onChange={(e, { value }) => this.setState({ location: value })}
                    />
                    <Form.Dropdown
                      upward
                      label="with template"
                      defaultValue={template}
                      options={[
                        { text: 'Regular Fleetcor', value: 'default' },
                        { text: 'Regular Fuelman', value: 'fuelman' },
                        { text: 'E15 Misclassified (A09 as e15)', value: 'e15Misclassified' },
                        { text: 'Over-threshold Fuelman ($325)', value: 'mediumFuelman' },
                        { text: 'Over AUTH_300 Fuelman ($650)', value: 'largeFuelman' },
                        { text: 'Fuel and Instore Purchase', value: 'fuelAndInStorePurchase' },
                        { text: 'Instore Purchase', value: 'inStorePurchase' },
                        { text: 'Large Instore Purchase', value: 'bigInStorePurchase' },
                        { text: 'Negative Transaction', value: 'negative' },
                      ]}
                      onChange={(e, { value }) => this.setState({ template: value })}
                    />
                    <Form.Button onClick={this.createTransaction}>Create</Form.Button>
                  </Form.Group>
                </Form>
              )
            }
          {instrument
              && instrument.provider_name === 'pdi'
              && instrument.instrument_type === 'private_card'
              && (
                <Form horizontal error={!!txAuthError}>
                  {txAuthError
                  && (
                  <Message error>
                    Unable to create transaction auth:
                    <pre>{JSON.stringify(txAuthError, null, '\t')}</pre>
                  </Message>
                  )
                }
                  <Form.Group inline>
                    <Form.Dropdown
                      upward
                      label="Create a transaction auth @"
                      defaultValue={location}
                      options={[
                        { text: 'Shell - Boston', value: 'shell_boston' },
                        { text: 'CITGO', value: 'citgo' },
                      ]}
                      onChange={(e, { value }) => this.setState({ location: value })}
                    />
                    <Form.Dropdown
                      upward
                      label="with template"
                      defaultValue={template}
                      options={[
                        { text: 'Regular Fleetcor', value: 'default' },
                        { text: 'Regular Fuelman', value: 'fuelman' },
                        { text: 'Instore Purchase', value: 'inStorePurchase' },
                        { text: 'Com Data Network', value: 'cdnp' },
                      ]}
                      onChange={(e, { value }) => this.setState({ template: value })}
                    />
                    <Form.Button onClick={this.createTransactionAuth}>Create</Form.Button>
                  </Form.Group>
                </Form>
              )
            }
        </Segment>
      </div>
    );
  }
}

BaseInstrumentTools.propTypes = {
  instrument: PT.shape({
    instrument_id: PT.number,
    account_id: PT.number,
    instrument_type: PT.string,
    provider_name: PT.string,
    extra_data: PT.shape({
      tags: PT.arrayOf(PT.string),
    }),
  }),
  fulfillments: PT.arrayOf(PT.shape({
    ready_to_ship: PT.bool,
    ship_date: PT.string,
    payment_instrument_fulfillment_id: PT.number,
  })),
  mapId: PT.number,
  history: PT.shape({
    push: PT.func,
  }).isRequired,
  onChange: PT.func.isRequired,
};

BaseInstrumentTools.defaultProps = {
  instrument: null,
  fulfillments: [],
  mapId: 0,
};

export const InstrumentTools = withRouter(BaseInstrumentTools);
